import { jsx } from "react/jsx-runtime";
import cx from "classnames";
const Table = (props) => {
  const {
    prefix = "",
    fullWidth = false,
    inset = false,
    className,
    children,
    ...otherProps
  } = props;
  const classes = cx(
    `${prefix}table`,
    inset && `${prefix}table--inset`,
    fullWidth && `${prefix}table--full-width`,
    className
  );
  return /* @__PURE__ */ jsx("div", { className: classes, children: /* @__PURE__ */ jsx("table", { ...otherProps, children }) });
};
var Table_default = Table;
export {
  Table_default as default
};
